var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorumPayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 42,
    viewBox: "0 0 196 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.223 11.1996H189.86V8.30854H190.997V7.76953H188.086V8.30854H189.223V11.1996ZM195.23 11.1996L195.225 7.76953H194.701L193.363 10.0432L192.001 7.76953H191.477V11.1996H192.084V8.95536L193.211 10.8076H193.496L194.623 8.92596L194.628 11.1996H195.23Z",
    fill: "#2B2E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1779 30.2628H18.5911L30.0616 18.3835L23.8069 11.7879H0.390625L3.3048 6.3509C3.3113 6.33724 3.3211 6.32539 3.33333 6.31647C3.34555 6.30754 3.3598 6.30183 3.3748 6.2998H27.1663L31.5806 11.0893L38.4324 18.5032L27.9013 29.4788C27.6896 29.7285 27.4253 29.9282 27.1274 30.0637C26.8294 30.1993 26.5052 30.2673 26.1779 30.2628Z",
    fill: "url(#paint0_linear_11615_8015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4019 35.7003H0L5.88015 24.8438H17.2141L11.4019 35.7003Z",
    fill: "url(#paint1_linear_11615_8015)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2925 21.0083H7.89062L10.788 15.5713H22.1899L19.2925 21.0083Z",
    fill: "url(#paint2_linear_11615_8015)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.579 29.2424V23.3678L169.198 12.7599H173.249L177.641 20.0764L182.056 12.7599H185.8L179.395 23.4071V29.2418L175.579 29.2424ZM167.661 29.2424L166.198 25.7095H158.557L157.087 29.2424H153.178L160.525 12.7599H164.288L171.658 29.2424H167.661ZM159.765 22.8156H165.001L162.388 16.5071L159.765 22.8156ZM140.203 29.2411V12.7577H147.338C148.646 12.7255 149.945 12.9711 151.151 13.478C152.16 13.9066 153.02 14.6231 153.624 15.5376C154.223 16.4954 154.526 17.6081 154.497 18.7372C154.525 19.8596 154.221 20.9653 153.624 21.916C153.021 22.8308 152.16 23.5473 151.151 23.9756C149.946 24.4828 148.646 24.7284 147.338 24.6959H144.017V29.2411H140.203ZM144.017 21.5884H147.126C148.067 21.6615 149.003 21.3942 149.763 20.8352C150.056 20.5735 150.286 20.2493 150.437 19.8867C150.588 19.5241 150.656 19.1323 150.635 18.7401C150.657 18.344 150.59 17.9479 150.44 17.5809C150.289 17.2139 150.058 16.8852 149.763 16.6191C149.002 16.0614 148.067 15.7943 147.126 15.8659H144.017V21.5884Z",
    fill: "url(#paint3_linear_11615_8015)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9922 15.5054H51.3018V29.0158H54.2776V15.5054H59.5893V12.9854H45.9922V15.5054Z",
    fill: "#2B2E3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2677 15.1056C74.4761 14.3578 73.5468 13.771 72.5313 13.3779C70.3123 12.5537 67.8712 12.5537 65.6522 13.3779C64.6322 13.7691 63.6986 14.356 62.904 15.1056C62.1286 15.8424 61.513 16.7306 61.0951 17.7152C60.2391 19.8217 60.2391 22.1791 61.0951 24.2856C61.512 25.2707 62.1278 26.1592 62.904 26.8953C63.6981 27.6456 64.6319 28.2326 65.6522 28.6229C66.7557 29.0441 67.9286 29.2538 69.1096 29.241C70.279 29.2534 71.4401 29.0436 72.5313 28.6229C73.5449 28.2305 74.4738 27.6474 75.2677 26.9051C76.0465 26.1712 76.6627 25.2822 77.0765 24.2954C77.5119 23.2513 77.7303 22.1295 77.7184 20.9983C77.7311 19.8709 77.5126 18.7529 77.0765 17.7131C76.6582 16.7294 76.0425 15.842 75.2677 15.1056ZM74.2968 23.2601C74.0228 23.9256 73.6225 24.5318 73.1179 25.0451C72.6113 25.5578 72.0033 25.9593 71.3329 26.224C69.8881 26.7734 68.2919 26.7734 66.8472 26.224C66.1765 25.9598 65.5684 25.5582 65.0621 25.0451C64.555 24.5294 64.1544 23.9188 63.8833 23.2482C63.3179 21.8023 63.3179 20.1965 63.8833 18.7506C64.1577 18.0825 64.5622 17.4757 65.0733 16.9655C65.5824 16.4558 66.1897 16.0547 66.8584 15.7867C67.5689 15.5056 68.3274 15.3656 69.0914 15.3744C69.8577 15.3667 70.6182 15.5067 71.3315 15.7867C72.0022 16.0509 72.6102 16.4524 73.1165 16.9655C73.6206 17.4792 74.0209 18.0853 74.2954 18.7506C74.862 20.2003 74.862 21.8103 74.2954 23.2601H74.2968Z",
    fill: "#2B2E3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1283 23.6684C92.0853 23.2662 92.9016 22.5892 93.474 21.7231C94.04 20.8146 94.3265 19.7599 94.2979 18.6899C94.3255 17.6163 94.0391 16.5581 93.474 15.6448C92.9031 14.7718 92.087 14.0868 91.1283 13.6757C89.9736 13.1904 88.729 12.9561 87.477 12.9883H80.8828V29.0117H83.8586V24.3419H87.4763C87.6905 24.3419 87.8963 24.3363 88.1021 24.3243L91.3691 29.0145H94.5751L90.8959 23.7643C90.9715 23.7321 91.0513 23.702 91.1283 23.6684ZM90.3043 16.3295C90.6405 16.6194 90.9054 16.9829 91.0783 17.3918C91.2512 17.8007 91.3274 18.2439 91.3012 18.6871C91.3242 19.1299 91.2465 19.5722 91.0738 19.9805C90.9011 20.3889 90.638 20.7528 90.3043 21.0448C89.448 21.6694 88.3977 21.9698 87.3405 21.8925H83.8614V15.5048H87.3405C88.3941 15.4286 89.4415 15.72 90.3043 16.3295Z",
    fill: "#2B2E3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.588 21.9164C108.588 23.5648 108.237 24.7627 107.534 25.5103C106.7 26.2337 105.633 26.6319 104.529 26.6319C103.425 26.6319 102.358 26.2337 101.524 25.5103C100.815 24.7637 100.46 23.5657 100.46 21.9164V12.9863H97.4844V22.0292C97.4844 24.3653 98.1065 26.1511 99.3506 27.3864C100.8 28.5851 102.621 29.241 104.502 29.241C106.383 29.241 108.204 28.5851 109.654 27.3864C110.898 26.1502 111.52 24.3644 111.52 22.0292V12.9863H108.589V21.9164H108.588Z",
    fill: "#2B2E3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 29.0148L132.624 12.9844H130.174L123.918 23.6043L117.559 12.9879H115.109V29.0183H117.947V18.5355L123.213 27.1821H124.543L129.811 18.3969L129.831 29.0148H132.648Z",
    fill: "#2B2E3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11615_8015",
    x1: 45.3179,
    y1: 11.6436,
    x2: -0.952071,
    y2: 37.1319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D43FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11615_8015",
    x1: 60.0945,
    y1: 19.0246,
    x2: 1.16701,
    y2: 51.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D43FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11615_8015",
    x1: 45.1688,
    y1: 11.7055,
    x2: 23.2398,
    y2: 44.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D43FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11615_8015",
    x1: 191.864,
    y1: 16.9097,
    x2: 162.261,
    y2: 52.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D43FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorumPayLogo);
export default __webpack_public_path__ + "static/media/torum-pay-logo.dc0f607f3a46504dd038eadb6307a0b0.svg";
export { ForwardRef as ReactComponent };